import { render, staticRenderFns } from "./costHelpThirtyTage.vue?vue&type=template&id=67d4594f&"
import script from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d4594f')) {
      api.createRecord('67d4594f', component.options)
    } else {
      api.reload('67d4594f', component.options)
    }
    module.hot.accept("./costHelpThirtyTage.vue?vue&type=template&id=67d4594f&", function () {
      api.rerender('67d4594f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-268mzVIqTumMG/JS/costHelpThirtyTage.vue"
export default component.exports